export const badHttpCodes = [400, 409];
